"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SoapMessages = void 0;
const react_1 = __importStar(require("react"));
const react_intl_1 = require("react-intl");
const evidence_1 = require("../../../../../composite/evidence/evidence");
const messages_fields_1 = require("./messages-fields");
const messages_columns_1 = require("./messages-columns");
const authored_evidence_1 = require("../../../../../composite/evidence/authored-evidence/authored-evidence");
const admin_context_1 = require("../../../admin-context");
function SoapMessages() {
    const intl = react_intl_1.useIntl();
    const { soapMessagesUrl } = react_1.useContext(admin_context_1.AdminContext);
    const evidence = authored_evidence_1.useAuthoredEvidence({
        identifier: 'SOAP_MESSAGES',
        apiProps: {
            url: soapMessagesUrl,
        },
        tableProps: {
            columns: messages_columns_1.useColumns(),
            tableName: intl.formatMessage({
                id: 'EAS_SOAP_LOGGER_MESSAGES_TABLE_TITLE',
                defaultMessage: 'SOAP komunikace',
            }),
        },
        detailProps: {
            FieldsComponent: messages_fields_1.MessagesFields,
        },
    });
    return react_1.default.createElement(evidence_1.Evidence, Object.assign({}, evidence));
}
exports.SoapMessages = SoapMessages;
//# sourceMappingURL=messages.js.map